export default {
  'Company profile details': 'Company profile details',
  // Modal
  // - KYC not completed
  'Permission denied': 'Permission denied',
  'Only verified profiles have access to this feature':
    'Only verified profiles have access to this feature',
  'Please complete company profile': 'Please complete company profile',
  'Upload company documents': 'Upload company documents',
  // - KYC wait
  'Please, wait': 'Please, wait',
  'We are verifying your company right now': 'We are verifying your company right now',
  'It may take up to 1-2 business days. We will notify you as soon as your company has been verified':
    'It may take up to 1-2 business days. We will notify you as soon as your company has been verified',
  // - KYC thanks
  'Thank you for company profile completion': 'Thank you for company profile completion',
  'We will review your company profile. We will notify you as soon as your account is upgraded.':
    'We will review your company profile. We will notify you as soon as your account is upgraded.',
  'Go to the dashboard': 'Go to the dashboard',
  // Company details
  'Company details': 'Company details',
  'Do you want to proceed?': 'Do you want to proceed?',
  'You have changed legal type. This may lead to the loss of attached documents.':
    'You have changed legal type. This may lead to the loss of attached documents.',
  'Basic Information about your company': 'Basic Information about your company',
  'This must be the location where you take payments and where we can reach you':
    'This must be the location where you take payments and where we can reach you',
  // Company address
  'Company address': 'Company address',
  // Primary company documents
  'Primary company documents': 'Primary company document',
  'Incorporation certificate or business license scan':
    'Incorporation certificate or business license scan',
  'Please select type of document and click to upload documents scan(s)':
    'Please select type of document and click to upload document scan(s)',
  'Document type': 'Document type',
  'Save primary document': 'Save primary document',
  'Trade name': 'Trade name',
  // Additional company documents
  'Additional company documents': 'Additional company documents',
  'Information about company owners, extra documents':
    'Information about company owners, extra documents',
  'Select type of submitted information and click to upload document scan(s)':
    'Select type of submitted information and click to upload document scan(s)',
  'Add document': 'Add document',
  'New document': 'New document',
  'Save additional documents': 'Save additional documents',
  // Payout details
  'Payout details': 'Payout details',
  'Bank account details for payout': 'Bank account details for payout',
  'Input bank details for payouts.': 'Input bank details for payouts.',
  Finish: 'Finish',
  // Other
  'Delete document': 'Delete document',
  'Preview file': 'Preview file',
  startApplication: 'Start application',
  startApplicationDescription: 'Start your application by clicking the button below.',
  collectData: 'Collect data',
  collectDataDescription:
    'Gather your documents and information needed to complete the application process.',
  startButtonDescription: 'Click button to start your application process.',
  completeButtonDescription: 'Click button to complete your application process.',
  startButtonText: 'Start Application',
  completeButtonText: 'Complete data',
};
